webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(599),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(573),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var route = 'https://beaumontortho.com/wp-json';

var api = function api() {
  return route;
};

exports.default = api();

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_PAGES = exports.GET_PAGES = 'GET_PAGES';
var GET_APP = exports.GET_APP = 'GET_APP';
var VIEW_NAV = exports.VIEW_NAV = 'VIEW_NAV';
var VIEW_BODY = exports.VIEW_BODY = 'VIEW_BODY';
var VIEW_TYPES = exports.VIEW_TYPES = 'VIEW_TYPES';
var VIEW_SHOWMODAL = exports.VIEW_SHOWMODAL = 'VIEW_SHOWMODAL';
var VIEW_MODALCONTENT = exports.VIEW_MODALCONTENT = 'VIEW_MODALCONTENT';

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(263);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(123);

var _vue2 = _interopRequireDefault(_vue);

var _app = __webpack_require__(518);

var _app2 = _interopRequireDefault(_app);

var _router = __webpack_require__(202);

var _router2 = _interopRequireDefault(_router);

var _veeValidate = __webpack_require__(517);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _store = __webpack_require__(205);

var _store2 = _interopRequireDefault(_store);

var _filters = __webpack_require__(203);

var customFilters = _interopRequireWildcard(_filters);

var _vueScrollto = __webpack_require__(622);

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

(0, _keys2.default)(customFilters).forEach(function (key) {
  _vue2.default.filter(key, customFilters[key]);
});

_vue2.default.use(_veeValidate2.default);

_vue2.default.use(_vueScrollto2.default, {
  container: 'body',
  duration: 1500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

new _vue2.default({
  router: _router2.default,
  template: '<App/>',
  store: _store2.default,
  render: function render(h) {
    return h(_app2.default);
  }
}).$mount('#app');

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(123);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(621);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _home = __webpack_require__(541);

var _home2 = _interopRequireDefault(_home);

var _aboutUs = __webpack_require__(522);

var _aboutUs2 = _interopRequireDefault(_aboutUs);

var _ = __webpack_require__(521);

var _2 = _interopRequireDefault(_);

var _meetTheDoctors = __webpack_require__(546);

var _meetTheDoctors2 = _interopRequireDefault(_meetTheDoctors);

var _meetOurStaff = __webpack_require__(545);

var _meetOurStaff2 = _interopRequireDefault(_meetOurStaff);

var _financialAndInsurance = __webpack_require__(536);

var _financialAndInsurance2 = _interopRequireDefault(_financialAndInsurance);

var _officePoliciesAndMission = __webpack_require__(547);

var _officePoliciesAndMission2 = _interopRequireDefault(_officePoliciesAndMission);

var _mapAndDirections = __webpack_require__(544);

var _mapAndDirections2 = _interopRequireDefault(_mapAndDirections);

var _patientTestimonials = __webpack_require__(553);

var _patientTestimonials2 = _interopRequireDefault(_patientTestimonials);

var _officeTourAndPhotoGallery = __webpack_require__(548);

var _officeTourAndPhotoGallery2 = _interopRequireDefault(_officeTourAndPhotoGallery);

var _practiceEvents = __webpack_require__(555);

var _practiceEvents2 = _interopRequireDefault(_practiceEvents);

var _ourBeaumontTxOffice = __webpack_require__(549);

var _ourBeaumontTxOffice2 = _interopRequireDefault(_ourBeaumontTxOffice);

var _referOurOffice = __webpack_require__(557);

var _referOurOffice2 = _interopRequireDefault(_referOurOffice);

var _appointmentRequest = __webpack_require__(525);

var _appointmentRequest2 = _interopRequireDefault(_appointmentRequest);

var _whyChooseUs = __webpack_require__(565);

var _whyChooseUs2 = _interopRequireDefault(_whyChooseUs);

var _firstVisit = __webpack_require__(537);

var _firstVisit2 = _interopRequireDefault(_firstVisit);

var _faq = __webpack_require__(534);

var _faq2 = _interopRequireDefault(_faq);

var _beforeAndAfterPhotos = __webpack_require__(527);

var _beforeAndAfterPhotos2 = _interopRequireDefault(_beforeAndAfterPhotos);

var _commonProblems = __webpack_require__(530);

var _commonProblems2 = _interopRequireDefault(_commonProblems);

var _emergencyInfo = __webpack_require__(533);

var _emergencyInfo2 = _interopRequireDefault(_emergencyInfo);

var _foodsToAvoid = __webpack_require__(538);

var _foodsToAvoid2 = _interopRequireDefault(_foodsToAvoid);

var _brushingAndFlossing = __webpack_require__(529);

var _brushingAndFlossing2 = _interopRequireDefault(_brushingAndFlossing);

var _whenToSeeAnOrthodontist = __webpack_require__(564);

var _whenToSeeAnOrthodontist2 = _interopRequireDefault(_whenToSeeAnOrthodontist);

var _earlyTreatment = __webpack_require__(532);

var _earlyTreatment2 = _interopRequireDefault(_earlyTreatment);

var _phaseIiAdolescentTreatment = __webpack_require__(554);

var _phaseIiAdolescentTreatment2 = _interopRequireDefault(_phaseIiAdolescentTreatment);

var _adultTreatment = __webpack_require__(524);

var _adultTreatment2 = _interopRequireDefault(_adultTreatment);

var _typesOfBraces = __webpack_require__(563);

var _typesOfBraces2 = _interopRequireDefault(_typesOfBraces);

var _invisalign = __webpack_require__(542);

var _invisalign2 = _interopRequireDefault(_invisalign);

var _retention = __webpack_require__(559);

var _retention2 = _interopRequireDefault(_retention);

var _jawSurgery = __webpack_require__(543);

var _jawSurgery2 = _interopRequireDefault(_jawSurgery);

var _tmj = __webpack_require__(562);

var _tmj2 = _interopRequireDefault(_tmj);

var _palatalExpander = __webpack_require__(550);

var _palatalExpander2 = _interopRequireDefault(_palatalExpander);

var _games = __webpack_require__(539);

var _games2 = _interopRequireDefault(_games);

var _bandColorChooser = __webpack_require__(526);

var _bandColorChooser2 = _interopRequireDefault(_bandColorChooser);

var _relatedLinks = __webpack_require__(558);

var _relatedLinks2 = _interopRequireDefault(_relatedLinks);

var _patientGallery = __webpack_require__(552);

var _patientGallery2 = _interopRequireDefault(_patientGallery);

var _glossary = __webpack_require__(540);

var _glossary2 = _interopRequireDefault(_glossary);

var _partsOfBraces = __webpack_require__(551);

var _partsOfBraces2 = _interopRequireDefault(_partsOfBraces);

var _feedback = __webpack_require__(535);

var _feedback2 = _interopRequireDefault(_feedback);

var _contactUs = __webpack_require__(531);

var _contactUs2 = _interopRequireDefault(_contactUs);

var _blog = __webpack_require__(528);

var _blog2 = _interopRequireDefault(_blog);

var _privacyPolicy = __webpack_require__(556);

var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);

var _siteDirectory = __webpack_require__(560);

var _siteDirectory2 = _interopRequireDefault(_siteDirectory);

var _thankYou = __webpack_require__(561);

var _thankYou2 = _interopRequireDefault(_thankYou);

var _accessibility = __webpack_require__(523);

var _accessibility2 = _interopRequireDefault(_accessibility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    navigation: true,
    component: _home2.default
  }, {
    path: '/about-us',
    name: 'about-us',
    navigation: true,
    component: _aboutUs2.default
  }, {
    path: '/meet-the-doctors',
    name: 'meet-the-doctors',
    navigation: true,
    component: _meetTheDoctors2.default
  }, {
    path: '/meet-our-staff',
    name: 'meet-our-staff',
    navigation: true,
    component: _meetOurStaff2.default
  }, {
    path: '/financial-and-insurance',
    name: 'financial-and-insurance',
    navigation: true,
    component: _financialAndInsurance2.default
  }, {
    path: '/office-policies-and-mission',
    name: 'office-policies-and-mission',
    navigation: true,
    component: _officePoliciesAndMission2.default
  }, {
    path: '/map-and-directions',
    name: 'map-and-directions',
    navigation: true,
    component: _mapAndDirections2.default
  }, {
    path: '/patient-testimonials',
    name: 'patient-testimonials',
    navigation: true,
    component: _patientTestimonials2.default
  }, {
    path: '/office-tour-and-photo-gallery',
    name: 'office-tour-and-photo-gallery',
    navigation: true,
    component: _officeTourAndPhotoGallery2.default
  }, {
    path: '/practice-events',
    name: 'practice-events',
    navigation: true,
    component: _practiceEvents2.default
  }, {
    path: '/our-beaumont-tx-office',
    name: 'our-beaumont-tx-office',
    navigation: true,
    component: _ourBeaumontTxOffice2.default
  }, {
    path: '/refer-our-office',
    name: 'refer-our-office',
    navigation: true,
    component: _referOurOffice2.default
  }, {
    path: '/appointment-request',
    name: 'appointment-request',
    navigation: true,
    component: _appointmentRequest2.default
  }, {
    path: '/why-choose-us',
    name: 'why-choose-us',
    navigation: true,
    component: _whyChooseUs2.default
  }, {
    path: '/first-visit',
    name: 'first-visit',
    navigation: true,
    component: _firstVisit2.default
  }, {
    path: '/faq',
    name: 'faq',
    navigation: true,
    component: _faq2.default
  }, {
    path: '/before-and-after-photos',
    name: 'before-and-after-photos',
    navigation: true,
    component: _beforeAndAfterPhotos2.default
  }, {
    path: '/common-problems',
    name: 'common-problems',
    navigation: true,
    component: _commonProblems2.default
  }, {
    path: '/emergency-info',
    name: 'emergency-info',
    navigation: true,
    component: _emergencyInfo2.default
  }, {
    path: '/foods-to-avoid',
    name: 'foods-to-avoid',
    navigation: true,
    component: _foodsToAvoid2.default
  }, {
    path: '/brushing-and-flossing',
    name: 'brushing-and-flossing',
    navigation: true,
    component: _brushingAndFlossing2.default
  }, {
    path: '/when-to-see-an-orthodontist',
    name: 'when-to-see-an-orthodontist',
    navigation: true,
    component: _whenToSeeAnOrthodontist2.default
  }, {
    path: '/early-treatment',
    name: 'early-treatment',
    navigation: true,
    component: _earlyTreatment2.default
  }, {
    path: '/phase-ii-adolescent-treatment',
    name: 'phase-ii-adolescent-treatment',
    navigation: true,
    component: _phaseIiAdolescentTreatment2.default
  }, {
    path: '/adult-treatment',
    name: 'adult-treatment',
    navigation: true,
    component: _adultTreatment2.default
  }, {
    path: '/types-of-braces',
    name: 'types-of-braces',
    navigation: true,
    component: _typesOfBraces2.default
  }, {
    path: '/invisalign',
    name: 'invisalign',
    navigation: true,
    component: _invisalign2.default
  }, {
    path: '/retention',
    name: 'retention',
    navigation: true,
    component: _retention2.default
  }, {
    path: '/jaw-surgery',
    name: 'jaw-surgery',
    navigation: true,
    component: _jawSurgery2.default
  }, {
    path: '/tmj',
    name: 'tmj',
    navigation: true,
    component: _tmj2.default
  }, {
    path: '/palatal-expander',
    name: 'palatal-expander',
    navigation: true,
    component: _palatalExpander2.default
  }, {
    path: '/games',
    name: 'games',
    navigation: true,
    component: _games2.default
  }, {
    path: '/band-color-chooser',
    name: 'band-color-chooser',
    navigation: true,
    component: _bandColorChooser2.default
  }, {
    path: '/related-links',
    name: 'related-links',
    navigation: true,
    component: _relatedLinks2.default
  }, {
    path: '/patient-gallery',
    name: 'patient-gallery',
    navigation: true,
    component: _patientGallery2.default
  }, {
    path: '/glossary',
    name: 'glossary',
    navigation: true,
    component: _glossary2.default
  }, {
    path: '/parts-of-braces',
    name: 'parts-of-braces',
    navigation: true,
    component: _partsOfBraces2.default
  }, {
    path: '/feedback',
    name: 'feedback',
    navigation: true,
    component: _feedback2.default
  }, {
    path: '/contact-us',
    name: 'contact-us',
    navigation: true,
    component: _contactUs2.default
  }, {
    path: '/blog',
    name: 'blog',
    navigation: true,
    component: _blog2.default
  }, {
    path: '/privacy-policy',
    name: 'privacy-policy',
    navigation: true,
    component: _privacyPolicy2.default
  }, {
    path: '/site-directory',
    name: 'site-directory',
    navigation: true,
    component: _siteDirectory2.default
  }, {
    path: '/thank-you',
    name: 'thank-you',
    navigation: true,
    component: _thankYou2.default
  }, {
    path: '/accessibility',
    name: 'accessibility',
    navigation: false,
    component: _accessibility2.default
  }, {
    path: '/*',
    name: 'page-not-found',
    navigation: false,
    component: _2.default
  }]
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

exports.default = router;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relativePath = relativePath;
exports.formatPhone = formatPhone;
function relativePath(value) {
  var apiRoot = 'http://mastroianni.roostertest3.com';
  return value.replace(apiRoot, '');
}

function formatPhone(value) {
  return value.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(267);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = __webpack_require__(131);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(266);

var _extends5 = _interopRequireDefault(_extends4);

var _asyncToGenerator2 = __webpack_require__(265);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__(184);

var _axios2 = _interopRequireDefault(_axios);

var _api = __webpack_require__(129);

var _api2 = _interopRequireDefault(_api);

var _mutationTypes = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = {
  GET_PAGES: function GET_PAGES(_ref) {
    var _this = this;

    var commit = _ref.commit;

    (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var response, data;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios2.default.get(_api2.default + '/wp/v2/pages?per_page=100');

            case 3:
              response = _context.sent;
              data = response.data.reduce(function (allData, data) {
                return (0, _extends5.default)({}, allData, (0, _defineProperty3.default)({}, data.slug, data));
              }, {});

              commit(_mutationTypes.GET_PAGES, data);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              console.log('PAGES API: ' + _context.t0);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  GET_APP: function GET_APP(_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;

    (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var response, data;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _axios2.default.get(_api2.default + '/wp/v2/app');

            case 3:
              response = _context2.sent;
              data = response.data.reduce(function (allData, data) {
                return (0, _extends5.default)({}, allData, (0, _defineProperty3.default)({}, data.slug, data));
              }, {});

              commit(_mutationTypes.GET_APP, data);
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);
              console.log('APP API: ' + _context2.t0);
            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  VIEW_NAV: function VIEW_NAV(_ref5, data) {
    var commit = _ref5.commit;

    commit(_mutationTypes.VIEW_NAV, data);
  },
  VIEW_BODY: function VIEW_BODY(_ref6, data) {
    var commit = _ref6.commit;

    commit(_mutationTypes.VIEW_BODY, data);
  },
  VIEW_TYPES: function VIEW_TYPES(_ref7, data) {
    var commit = _ref7.commit;

    commit(_mutationTypes.VIEW_TYPES, data);
  },
  VIEW_SHOWMODAL: function VIEW_SHOWMODAL(_ref8, data) {
    var commit = _ref8.commit;

    commit(_mutationTypes.VIEW_SHOWMODAL, data);
  },
  VIEW_MODALCONTENT: function VIEW_MODALCONTENT(_ref9, data) {
    var commit = _ref9.commit;

    commit(_mutationTypes.VIEW_MODALCONTENT, data);
  }
};

exports.default = actions;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(123);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(624);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(206);

var _mutations2 = _interopRequireDefault(_mutations);

var _actions = __webpack_require__(204);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    app: {},
    pages: {},
    nav: {},

    body: {},
    types: {},
    showModal: {},
    modalContent: {},
    loading: true
  },
  mutations: _mutations2.default,
  actions: _actions2.default
});

exports.default = store;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(131);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.GET_PAGES, function (state, data) {
  state.pages = data;
  state.loading = false;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.GET_APP, function (state, data) {
  state.app = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_NAV, function (state, data) {
  state.nav = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_BODY, function (state, data) {
  state.body = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_TYPES, function (state, data) {
  state.types = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_SHOWMODAL, function (state, data) {
  state.showModal = data;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.VIEW_MODALCONTENT, function (state, data) {
  state.modalContent = data;
}), _mutations);

exports.default = mutations;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigation = __webpack_require__(181);

var _navigation2 = _interopRequireDefault(_navigation);

var _revisions = __webpack_require__(566);

var _revisions2 = _interopRequireDefault(_revisions);

var _index = __webpack_require__(519);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  created: function created() {
    this.$store.dispatch('GET_PAGES');
    this.$store.dispatch('GET_APP');
    this.$store.dispatch('VIEW_NAV', false);
    this.$store.dispatch('VIEW_BODY', false);
    this.$store.dispatch('VIEW_TYPES', 0);
    this.$store.dispatch('VIEW_SHOWMODAL', false);
    this.$store.dispatch('VIEW_MODALCONTENT', false);
  },

  computed: {
    props: function props() {
      return this.$store.state;
    }
  },
  components: {
    Navigation: _navigation2.default,
    Revisions: _revisions2.default,
    BaseBaseAccess: _index2.default
  },
  name: 'app'
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      companyName: 'Beaumont Orthodontics',
      domain: "<a href='https://beaumontortho.com'>beaumontortho.com</a>",
      email: "<a href='mailto:info@beaumontortho.com'>info@beaumontortho.com</a>",
      phone: "<a href='tel:+14098322200'>(409) 832-2200</a>",
      formattedEmail: ''
    };
  }
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'footer',
  computed: {
    props: function props() {
      return this.$store.state.pages['footer'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  }
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigation = __webpack_require__(181);

var _navigation2 = _interopRequireDefault(_navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'header',
  computed: {
    props: function props() {
      return this.$store.state.pages.header;
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Navigation: _navigation2.default
  }
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  computed: {
    props: function props() {
      return this.$router.options.routes;
    }
  }
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'side-bar',
  computed: {
    props: function props() {
      return this.$store.state.pages['side-bar'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  }
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  computed: {
    props: function props() {
      return this.$router.options.routes;
    }
  }
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    props: function props() {
      return this.$router.options.routes;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'about-us',
  computed: {
    props: function props() {
      return this.$store.state.pages['about-us'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default
  }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Accessibility',
  computed: {
    props: function props() {
      return this.$store.state.pages['thank-you'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  },
  data: function data() {
    return {
      companyName: 'Beaumont Orthodontics',
      domain: "<a href='https://beaumontortho.com'>beaumontortho.com</a>",
      email: "<a href='mailto:info@beaumontortho.com'>info@beaumontortho.com</a>",
      phone: "<a href='tel:+14098322200'>(409) 832-2200</a>",
      formattedEmail: ''
    };
  },
  mounted: function mounted() {
    this.formatEmail();
  },

  methods: {
    formatEmail: function formatEmail() {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>';
    }
  }
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'adult-treatment',
  computed: {
    props: function props() {
      return this.$store.state.pages['adult-treatment'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueRecaptcha = __webpack_require__(122);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'appointment-request',
  computed: {
    props: function props() {
      return this.$store.state.pages['appointment-request'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default,
    VueRecaptcha: _vueRecaptcha2.default
  }
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'band-color-chooser',
  computed: {
    props: function props() {
      return this.$store.state.pages['band-color-chooser'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'before-and-after-photos',
  computed: {
    props: function props() {
      return this.$store.state.pages['before-and-after-photos'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'blog',
  computed: {
    props: function props() {
      return this.$store.state.pages['blog'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'brushing-and-flossing',
  computed: {
    props: function props() {
      return this.$store.state.pages['brushing-and-flossing'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'common-problems',
  computed: {
    props: function props() {
      return this.$store.state.pages['common-problems'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'contact-us',
  computed: {
    props: function props() {
      return this.$store.state.pages['contact-us'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'early-treatment',
  computed: {
    props: function props() {
      return this.$store.state.pages['early-treatment'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'emergency-info',
  computed: {
    props: function props() {
      return this.$store.state.pages['emergency-info'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'faq',
  computed: {
    props: function props() {
      return this.$store.state.pages['faq'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueRecaptcha = __webpack_require__(122);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'feedback',
  computed: {
    props: function props() {
      return this.$store.state.pages['feedback'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default,
    VueRecaptcha: _vueRecaptcha2.default
  }
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'financial-and-insurance',
  computed: {
    props: function props() {
      return this.$store.state.pages['financial-and-insurance'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'first-visit',
  computed: {
    props: function props() {
      return this.$store.state.pages['first-visit'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'foods-to-avoid',
  computed: {
    props: function props() {
      return this.$store.state.pages['foods-to-avoid'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'games',
  computed: {
    props: function props() {
      return this.$store.state.pages['games'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'glossary',
  computed: {
    props: function props() {
      return this.$store.state.pages['glossary'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'home',
  computed: {
    props: function props() {
      return this.$store.state.pages.home;
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'invisalign',
  computed: {
    props: function props() {
      return this.$store.state.pages['invisalign'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'jaw-surgery',
  computed: {
    props: function props() {
      return this.$store.state.pages['jaw-surgery'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'map-and-directions',
  computed: {
    props: function props() {
      return this.$store.state.pages['map-and-directions'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'meet-our-staff',
  computed: {
    props: function props() {
      return this.$store.state.pages['meet-our-staff'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'meet-the-doctor',
  computed: {
    props: function props() {
      return this.$store.state.pages['meet-the-doctors'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'office-policies-and-mission',
  computed: {
    props: function props() {
      return this.$store.state.pages['office-policies-and-mission'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'office-tour-and-photo-gallery',
  computed: {
    props: function props() {
      return this.$store.state.pages['office-tour-and-photo-gallery'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'our-beaumont-tx-office',
  computed: {
    props: function props() {
      return this.$store.state.pages['our-beaumont-tx-office'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'palatal-expander',
  computed: {
    props: function props() {
      return this.$store.state.pages['palatal-expander'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'parts-of-braces',
  computed: {
    props: function props() {
      return this.$store.state.pages['parts-of-braces'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'patient-gallery',
  computed: {
    props: function props() {
      return this.$store.state.pages['patient-gallery'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'patient-testimonials',
  computed: {
    props: function props() {
      return this.$store.state.pages['patient-testimonials'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'phase-ii-adolescent-treatment',
  computed: {
    props: function props() {
      return this.$store.state.pages['phase-ii-adolescent-treatment'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'practice-events',
  computed: {
    props: function props() {
      return this.$store.state.pages['practice-events'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'privacy-policy',
  computed: {
    props: function props() {
      return this.$store.state.pages['privacy-policy'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueRecaptcha = __webpack_require__(122);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'refer-our-office',
  computed: {
    props: function props() {
      return this.$store.state.pages['refer-our-office'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default,
    VueRecaptcha: _vueRecaptcha2.default
  }
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'related-links',
  computed: {
    props: function props() {
      return this.$store.state.pages['related-links'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'retention',
  computed: {
    props: function props() {
      return this.$store.state.pages['retention'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _sitemap = __webpack_require__(520);

var _sitemap2 = _interopRequireDefault(_sitemap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'site-directory',
  computed: {
    props: function props() {
      return this.$store.state.pages['site-directory'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default,
    Sitemap: _sitemap2.default
  }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'thank-you',
  computed: {
    props: function props() {
      return this.$store.state.pages['thank-you'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'tmj',
  computed: {
    props: function props() {
      return this.$store.state.pages['tmj'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'types-of-braces',
  computed: {
    props: function props() {
      return this.$store.state.pages['types-of-braces'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'when-to-see-an-orthodontist',
  computed: {
    props: function props() {
      return this.$store.state.pages['when-to-see-an-orthodontist'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loader = __webpack_require__(2);

var _loader2 = _interopRequireDefault(_loader);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _sidebar = __webpack_require__(5);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'why-choose-us',
  computed: {
    props: function props() {
      return this.$store.state.pages['why-choose-us'];
    },
    loading: function loading() {
      return this.$store.state.loading;
    }
  },
  components: {
    Loader: _loader2.default,
    Header: _header2.default,
    Sidebar: _sidebar2.default,
    Footer: _footer2.default
  }
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(129);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dev: false,
      active: false
    };
  },
  created: function created() {
    _api2.default.indexOf('roostertest3') === -1 ? '' : this.dev = true;
  }
};

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(595),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(614),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(568),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(574),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(586),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(583),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(620),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(589),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(617),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(607),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(605),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(601),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(577),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(591),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(581),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(576),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(615),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(613),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(593),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(575),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(604),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(609),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(594),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(579),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(578),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(611),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(616),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(619),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(608),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(582),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(610),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commonproblems"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Sitemap"
  }, [_c('h1', [_vm._v("Site Directory")]), _c('ul', {
    attrs: {
      "id": "mainmenu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "first"
    }
  }, [_vm._v("Office Info"), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-the-doctors",
      "onclick": "active1()"
    }
  }, [_vm._v("Meet the Doctors")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-our-staff",
      "onclick": "active1()"
    }
  }, [_vm._v("Meet Our Staff")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/office-policies-and-mission",
      "onclick": "active1()"
    }
  }, [_vm._v("Office Policies and Mission")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/map-and-directions",
      "onclick": "active1()"
    }
  }, [_vm._v("Map and Directions")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/financial-and-insurance",
      "onclick": "active1()"
    }
  }, [_vm._v("Financial and Insurance")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-testimonials",
      "onclick": "active1()"
    }
  }, [_vm._v("Patient Testimonials")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/office-tour-and-photo-gallery",
      "onclick": "active1()"
    }
  }, [_vm._v("Office Tour and Photo Gallery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/refer-our-office",
      "onclick": "active1()"
    }
  }, [_vm._v("Refer Our Office")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/practice-events",
      "onclick": "active1()"
    }
  }, [_vm._v("Practice Events")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/appointment-request",
      "onclick": "active1()"
    }
  }, [_vm._v("Appointment Request")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/our-beaumont-tx-office",
      "onclick": "active1()"
    }
  }, [_vm._v("Our Beaumont TX Office")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "two"
    }
  }, [_vm._v("Patient Info"), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/why-choose-us",
      "onclick": "active2()"
    }
  }, [_vm._v("Why Choose Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/first-visit",
      "onclick": "active2()"
    }
  }, [_vm._v("First Visit")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/faq",
      "onclick": "active2()"
    }
  }, [_vm._v("FAQ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/before-and-after-photos",
      "onclick": "active2()"
    }
  }, [_vm._v("Before and After Photos")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/brushing-and-flossing",
      "onclick": "active2()"
    }
  }, [_vm._v("Brushing and Flossing")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/common-problems",
      "onclick": "active2()"
    }
  }, [_vm._v("Common Problems")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/emergency-info",
      "onclick": "active2()"
    }
  }, [_vm._v("Emergency Info")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/foods-to-avoid",
      "onclick": "active2()"
    }
  }, [_vm._v("Foods to Avoid")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "three"
    }
  }, [_vm._v("Treatment Info  "), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/early-treatment",
      "onclick": "active3()"
    }
  }, [_vm._v("Early Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/phase-ii-adolescent-treatment",
      "onclick": "active3()"
    }
  }, [_vm._v("Phase II / Adolescent Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adult-treatment",
      "onclick": "active3()"
    }
  }, [_vm._v("Adult Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-braces",
      "onclick": "active3()"
    }
  }, [_vm._v("Types of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign",
      "onclick": "active3()"
    }
  }, [_vm._v("Invisalign")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/retention",
      "onclick": "active3()"
    }
  }, [_vm._v("Retention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/jaw-surgery",
      "onclick": "active3()"
    }
  }, [_vm._v("Jaw Surgery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tmj",
      "onclick": "active3()"
    }
  }, [_vm._v("TMJ       ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/palatal-expander",
      "onclick": "active3()"
    }
  }, [_vm._v("Palatal Expander         ")])], 1)])])], 1), _c('li', {
    staticClass: "funtabbar"
  }, [_c('router-link', {
    attrs: {
      "to": "",
      "id": "four"
    }
  }, [_vm._v("Fun Stuff"), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/games",
      "onclick": "active4()"
    }
  }, [_vm._v("Games")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/band-color-chooser",
      "onclick": "active4()"
    }
  }, [_vm._v("Band Color Chooser")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/related-links",
      "onclick": "active4()"
    }
  }, [_vm._v("Related Links")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-gallery",
      "onclick": "active4()"
    }
  }, [_vm._v("Patient Gallery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/glossary",
      "onclick": "active4()"
    }
  }, [_vm._v("Glossary")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/parts-of-braces",
      "onclick": "active4()"
    }
  }, [_vm._v("Parts of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/feedback",
      "onclick": "active4()"
    }
  }, [_vm._v("Feedback")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/blog",
      "onclick": "active4()"
    }
  }, [_vm._v("Blog ")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact-us"
    }
  }, [_vm._v("Contact Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/site-directory"
    }
  }, [_vm._v("Site Map")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy           ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation",
    attrs: {
      "id": "mainmenu1"
    }
  }, [_c('ul', {
    attrs: {
      "id": "mainmenu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "aria-label": "Home"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "first",
      "aria-label": "Home"
    }
  }, [_vm._v("Office Info"), _c('span', {
    staticClass: "dropdown",
    attrs: {
      "onclick": "subMOpen2()"
    }
  }), _c('ul', {
    staticClass: "submenu",
    attrs: {
      "id": "dropdown2"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-the-doctors",
      "onclick": "active1()",
      "aria-label": "Meet the Doctors"
    }
  }, [_vm._v("Meet the Doctors")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-our-staff",
      "onclick": "active1()",
      "aria-label": " Meet Our Staff"
    }
  }, [_vm._v("Meet Our Staff")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/office-policies-and-mission",
      "onclick": "active1()",
      "aria-label": "Office Policies and Mission"
    }
  }, [_vm._v("Office Policies and Mission")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/map-and-directions",
      "onclick": "active1()",
      "aria-label": "Map and Directions"
    }
  }, [_vm._v("Map and Directions")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/financial-and-insurance",
      "onclick": "active1()",
      "aria-label": "Financial and Insurance"
    }
  }, [_vm._v("Financial and Insurance")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-testimonials",
      "onclick": "active1()",
      "aria-label": "Patient Testimonials"
    }
  }, [_vm._v("Patient Testimonials")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/office-tour-and-photo-gallery",
      "onclick": "active1()",
      "aria-label": "Office Tour and Photo Gallery"
    }
  }, [_vm._v("Office Tour and Photo Gallery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/refer-our-office",
      "onclick": "active1()",
      "aria-label": "Refer Our Office"
    }
  }, [_vm._v("Refer Our Office")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/practice-events",
      "onclick": "active1()",
      "aria-label": "Practice Events"
    }
  }, [_vm._v("Practice Events")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/appointment-request",
      "onclick": "active1()",
      "aria-label": "Appointment Request"
    }
  }, [_vm._v("Appointment Request")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/our-beaumont-tx-office",
      "onclick": "active1()",
      "aria-label": "Our Beaumont TX Office"
    }
  }, [_vm._v("Our Beaumont TX Office")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "two",
      "aria-label": "Patient Info"
    }
  }, [_vm._v("Patient Info"), _c('span', {
    staticClass: "dropdown",
    attrs: {
      "onclick": "subMOpen3()"
    }
  }), _c('ul', {
    staticClass: "submenu",
    attrs: {
      "id": "dropdown3"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/why-choose-us",
      "onclick": "active2()",
      "aria-label": "Why Choose Us"
    }
  }, [_vm._v("Why Choose Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/first-visit",
      "onclick": "active2()",
      "aria-label": "First Visit"
    }
  }, [_vm._v("First Visit")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/faq",
      "onclick": "active2()",
      "aria-label": "FAQ"
    }
  }, [_vm._v("FAQ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/before-and-after-photos",
      "onclick": "active2()",
      "aria-label": "Before and After Photos"
    }
  }, [_vm._v("Before and After Photos")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/brushing-and-flossing",
      "onclick": "active2()",
      "aria-label": "Brushing and Flossing"
    }
  }, [_vm._v("Brushing and Flossing          ")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "three",
      "aria-label": "Treatment Info"
    }
  }, [_vm._v("Treatment Info"), _c('span', {
    staticClass: "dropdown",
    attrs: {
      "onclick": "subMOpen4()"
    }
  }), _c('ul', {
    staticClass: "submenu",
    attrs: {
      "id": "dropdown4"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/early-treatment",
      "onclick": "active3()",
      "aria-label": "Early Treatment"
    }
  }, [_vm._v("Early Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/phase-ii-adolescent-treatment",
      "onclick": "active3()",
      "aria-label": "Phase II / Adolescent Treatment"
    }
  }, [_vm._v("Phase II / Adolescent Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adult-treatment",
      "onclick": "active3()",
      "aria-label": "Adult Treatment"
    }
  }, [_vm._v("Adult Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-braces",
      "onclick": "active3()",
      "aria-label": "Types of Braces"
    }
  }, [_vm._v("Types of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign",
      "onclick": "active3()",
      "aria-label": "Invisalign"
    }
  }, [_vm._v("Invisalign")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/retention",
      "onclick": "active3()",
      "aria-label": "Retention"
    }
  }, [_vm._v("Retention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/jaw-surgery",
      "onclick": "active3()",
      "aria-label": "Jaw Surgery"
    }
  }, [_vm._v("Jaw Surgery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tmj",
      "onclick": "active3()",
      "aria-label": "TMJ"
    }
  }, [_vm._v("TMJ       ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/palatal-expander",
      "onclick": "active3()",
      "aria-label": "Palatal Expander"
    }
  }, [_vm._v("Palatal Expander         ")])], 1)])])], 1), _c('li', {
    staticClass: "funtabbar"
  }, [_c('router-link', {
    attrs: {
      "to": "",
      "id": "four",
      "aria-label": "Fun Stuff"
    }
  }, [_vm._v("Fun Stuff"), _c('span', {
    staticClass: "dropdown",
    attrs: {
      "onclick": "subMOpen5()"
    }
  }), _c('ul', {
    staticClass: "submenu",
    attrs: {
      "id": "dropdown5"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/games",
      "onclick": "active4()",
      "aria-label": "Games"
    }
  }, [_vm._v("Games")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/band-color-chooser",
      "onclick": "active4()",
      "aria-label": "Band Color Chooser"
    }
  }, [_vm._v("Band Color Chooser")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/related-links",
      "onclick": "active4()",
      "aria-label": "Related Links"
    }
  }, [_vm._v("Related Links")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-gallery",
      "onclick": "active4()",
      "aria-label": "Patient Gallery"
    }
  }, [_vm._v("Patient Gallery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/glossary",
      "onclick": "active4()",
      "aria-label": "Glossary"
    }
  }, [_vm._v("Glossary")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/parts-of-braces",
      "onclick": "active4()",
      "aria-label": "Parts of Braces"
    }
  }, [_vm._v("Parts of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/feedback",
      "onclick": "active4()",
      "aria-label": "Feedback"
    }
  }, [_vm._v("Feedback")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/blog",
      "onclick": "active4()",
      "aria-label": "Blog"
    }
  }, [_vm._v("Blog ")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact-us",
      "aria-label": "Contact Us"
    }
  }, [_vm._v("Contact Us     ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partsofbraces"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "earlytreatment"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacypolicy"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome phasewelcome prphasewelcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top"
  }, [_c('header', {
    staticClass: "site_header"
  }, [(_vm.props) ? _c('div', {
    staticClass: "tophead"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "h_address"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address)
    }
  })])]), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "h_phone"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone)
    }
  }), _c('router-link', {
    attrs: {
      "to": "/",
      "target": "_blank",
      "aria-label": "Home"
    }
  })], 1)]), _c('div', {
    staticClass: "middle"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "aria-label": "Home"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.logo.url,
      "alt": "logo"
    }
  })])], 1)]) : _vm._e(), _c('div', {
    staticClass: "homeslider"
  }, [_c('div', {
    staticClass: "innerslide"
  }, _vm._l((_vm.props.acf.actorslider), function(actorslider) {
    return (_vm.props) ? _c('div', {
      staticClass: "header-slider-inner"
    }, [_c('img', {
      staticClass: "slimg",
      attrs: {
        "src": actorslider.url,
        "alt": "slide"
      }
    })]) : _vm._e()
  })), _c('div', {
    staticClass: "home_social"
  }, [_c('router-link', {
    staticClass: "blogger_link",
    attrs: {
      "to": "/",
      "target": "_blank",
      "aria-label": "Home"
    }
  }), _c('a', {
    staticClass: "fb_link",
    attrs: {
      "href": "https://www.facebook.com/Beaumontortho",
      "target": "_blank",
      "aria-label": "facebook"
    }
  })], 1)]), _c('div', {
    staticClass: "test"
  }, [_vm._m(0), _c('Navigation')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "togglebt",
    attrs: {
      "onclick": "menuToggle()"
    }
  }, [_c('span'), _c('span'), _c('span')])
}]}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome phasewelcome prphasewelcome"
  }, [_vm._m(0), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content"
  }, [_c('h1', [_vm._v("404 Error Page")]), _c('div', [_c('h2', [_vm._v("Oops! Can't find that page!")])])])])
}]}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetthestaff"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "games"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome gamewelcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('h1', [_vm._v("Games ")]), _vm._l((_vm.props.acf.game_list), function(gameList) {
    return (_vm.props) ? _c('span', [_c('a', {
      attrs: {
        "href": gameList.game_url,
        "target": "_blank",
        "aria-label": "game url"
      }
    }, [_c('img', {
      attrs: {
        "src": gameList.game_logo,
        "alt": "game logo"
      }
    })])]) : _vm._e()
  })], 2), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faqer"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "practiceevents"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phaseiiadolescenttreatment"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome phasewelcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "f_links"
  }, [_vm._l((_vm.props.acf.client_lists), function(clientList) {
    return (_vm.props) ? _c('a', {
      attrs: {
        "href": clientList.client_url,
        "target": "_blank",
        "aria-label": "logo"
      }
    }, [_c('img', {
      attrs: {
        "src": clientList.client_logo,
        "alt": "logo"
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "f_address"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.suite_c)
    }
  })])], 2)]), _c('div', {
    staticClass: "seo"
  }, [_c('router-link', {
    staticClass: "directory",
    attrs: {
      "to": "/site-directory",
      "target": "_blank",
      "aria-label": "site directory"
    }
  }, [_vm._v("Site Map | "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.copy_right)
    }
  })]), _c('router-link', {
    attrs: {
      "to": "/",
      "target": "_blank",
      "aria-label": "Home"
    }
  }, [_vm._v("All Rights Reserved")]), _vm._v(" | "), _c('router-link', {
    attrs: {
      "to": "/privacy-policy",
      "target": "_blank",
      "aria-label": "Privacy Policy"
    }
  }, [_vm._v("Privacy Policy")])], 1), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#page'),
      expression: "'#page'"
    }],
    staticClass: "back-bar",
    attrs: {
      "id": "backTop",
      "href": "#"
    }
  }, [_c('a', {
    attrs: {
      "herf": "",
      "aria-label": "hello"
    }
  }, [_vm._v("hello")])]), _c('div', {
    attrs: {
      "id": "accessibilityWidget",
      "tabindex": "0"
    }
  }, [_vm._v("Click for Accessibility")])])
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financialandinsurance"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "typesofbraces"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thank-you page-access"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome phasewelcome prphasewelcome"
  }, [_c('div', {
    staticClass: "left access_wrap"
  }, [_c('div', {
    staticClass: "home-content"
  }, [_c('h2', {
    staticClass: "block-title",
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " Accessibility Statement"))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " is committed to facilitating the accessibility and usability of its website, " + _vm.domain + ", for everyone.  " + _vm.companyName + " aims to comply with all applicable standards, including the World Wide Web Consortiums Web Content Accessibility Guidelines 2.0 up to Level AA (WCAG 2.0 AA). " + _vm.companyName + " is proud of the efforts that we have completed and that are in-progress to ensure that our website is accessible to everyone."))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(("We highly recommend using the userway accessibility widget linked in the footer, but should you experience any difficulty in accessing any part of this website, please feel free to " + (_vm.phone ? "call us at " + _vm.phone : "") + " " + (_vm.phone && _vm.email ? "or" : "") + " " + (_vm.email ? "email us at " + _vm.formattedEmail : "") + " and we will work with you to provide the information or service you seek through an alternate communication method that is accessible for you consistent with applicable law (for example, through telephone support)."))
    }
  })])]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foodstoavoid"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Blog"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about-us"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading) ? _c('div', [_c('h1', [_vm._v("About Us Page")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patienttestimonials"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "officepoliciesandmission"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointmentrequest"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome allfrmptags"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1), _vm._m(0), _c('div', {
    staticClass: "main-form"
  }, [_c('div', {
    staticClass: "innerapp"
  }, [_c('form', {
    attrs: {
      "method": "POST",
      "action": "https://beaumontortho.com/email/"
    }
  }, [_c('div', {
    staticClass: "formboxes"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    attrs: {
      "type": "text",
      "name": "paitentName",
      "id": "paitentName"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _vm._m(2), _c('div', {
    staticClass: "formboxes"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    attrs: {
      "type": "email",
      "name": "emailId",
      "id": "emailId"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "formboxes"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    attrs: {
      "type": "text",
      "name": "address",
      "id": "address"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "formboxes"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    attrs: {
      "type": "text",
      "name": "phoneNo",
      "id": "phoneNo"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "formboxes"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    attrs: {
      "type": "text",
      "name": "preferredDays",
      "id": "preferredDays"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Convenient Times ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    attrs: {
      "type": "text",
      "name": "convenientTimes",
      "id": "convenientTimes"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })]), _vm._m(7), _vm._m(8), _vm._m(9), _vm._m(10), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfwfFwUAAAAAAUsIWtZ8aO3BS4O8lHPBoIwF7oi",
      "badge": "inline"
    }
  })], 1)]), _vm._m(11)])])]), _vm._m(12)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('h2', [_vm._v("Schedule An Appointment For Beaumont & Nederland, TX   Braces")]), _c('p', [_vm._v("We understand that you have a busy schedule, so we do our best to make scheduling an appointment with us as easy as possible. After filling out our form below, one of our friendly team members will contact you and work with you to schedule an appointment that works with your schedule.")]), _c('div', {
    staticClass: "clearboth"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Patient Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes radioformbox"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        New Patient ")]), _c('div', {
    staticClass: "radies"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "newPaitent",
      "value": "yes",
      "id": "newPaitent"
    }
  }), _vm._v("Yes")]), _c('div', {
    staticClass: "radies"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "newPaitent",
      "value": "no",
      "id": "newPaitent"
    }
  }), _vm._v("No  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Email ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Address ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Phone ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Preferred Days ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        How did you hear about our practice? ")]), _c('select', {
    attrs: {
      "id": "next09",
      "name": "hearPractice"
    }
  }, [_c('option', {
    attrs: {
      "value": "dentist"
    }
  }, [_vm._v("Dentist")]), _c('option', {
    attrs: {
      "value": "advertisement"
    }
  }, [_vm._v("Advertisement")]), _c('option', {
    attrs: {
      "value": "friend"
    }
  }, [_vm._v("A Friend")]), _c('option', {
    attrs: {
      "value": "internet"
    }
  }, [_vm._v("Internet")]), _c('option', {
    attrs: {
      "value": "staff"
    }
  }, [_vm._v("Staff Member")]), _c('option', {
    attrs: {
      "value": "yellowpages"
    }
  }, [_vm._v("Yellow Pages")]), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        How did you find our web site? ")]), _c('select', {
    attrs: {
      "id": "next03",
      "name": "findSite"
    }
  }, [_c('option', {
    attrs: {
      "value": "dentist"
    }
  }, [_vm._v("Dentist")]), _c('option', {
    attrs: {
      "value": "search"
    }
  }, [_vm._v("Search Engine")]), _c('option', {
    attrs: {
      "value": "advertisement"
    }
  }, [_vm._v("Advertisement")]), _c('option', {
    attrs: {
      "value": "friend"
    }
  }, [_vm._v("A Friend")]), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Name and Address of General Dentist ")]), _c('textarea', {
    attrs: {
      "name": "nameAddress",
      "id": "nameAddress"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Comments ")]), _c('textarea', {
    attrs: {
      "name": "comments"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt buttonallrt"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "Appointment Request"
    }
  }), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit Referral",
      "onclick": "return validateAPRForm()"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearboth"
  }, [_c('div', {
    staticClass: "left beauton"
  }, [_c('h2', [_vm._v("Contact Your Local Beaumont TX Orthodontist")]), _c('p', [_vm._v("We appreciate your interest in our orthodontic practice! Whether you are in need of Nederland TX braces, "), _c('a', {
    attrs: {
      "href": "/jaw-surgery"
    }
  }, [_vm._v("jaw surgery")]), _vm._v(" in Lumberton TX, or Invisalign in Beaumont TX, our team provides state-of-the-art, custom orthodontic care. "), _c('a', {
    attrs: {
      "href": "/contact-us"
    }
  }, [_vm._v("Contact us")]), _vm._v(" today or fill out the above form to schedule your appointment. We look forward to hearing from you!                         ")])])])
}]}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sitedirectory"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('Sitemap')], 1), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome allfrmptags"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1), _c('div', {
    staticClass: "left"
  }), _c('div', {
    staticClass: "main-form"
  }, [_c('div', {
    staticClass: "innerapp"
  }, [_c('form', {
    attrs: {
      "action": "https://beaumontortho.com/email/",
      "method": "post"
    }
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfwfFwUAAAAAAUsIWtZ8aO3BS4O8lHPBoIwF7oi",
      "badge": "inline"
    }
  })], 1)]), _vm._m(3)])])])])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Name")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "yourName",
      "id": "yourName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Email ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "EmailId",
      "id": "EmailId"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Feedback ")]), _c('textarea', {
    attrs: {
      "name": "yourFeedback",
      "id": "yourFeedback"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt buttonallrt"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "Feedback"
    }
  }), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit Feedback",
      "onclick": "return validateFeedback()"
    }
  })])])
}]}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whychooseus"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapanddirections"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patientgallery"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('BaseBaseAccess'), _c('router-view'), _c('Revisions')], 1)
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "firstvisit"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-content"
  }, [(_vm.props) ? _c('div', {
    staticClass: "callouts2"
  }, [_c('a', {
    staticClass: "call_forms",
    attrs: {
      "href": "https://goo.gl/UIPSGY",
      "target": "_blank"
    }
  }, [_vm._v("Write a Review")]), _c('router-link', {
    staticClass: "call_forms",
    attrs: {
      "to": "/first-visit"
    }
  }, [_vm._v("New Patient Forms")]), _c('router-link', {
    staticClass: "call_app",
    attrs: {
      "to": "/appointment-request"
    }
  }, [_vm._v("Appointment Request   ")])], 1) : _vm._e(), _c('div', {
    staticClass: "r_links"
  }, [_c('a', {
    staticClass: "cp_reach",
    attrs: {
      "href": "http://www.myreachportal.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bars,
      "alt": "myreachportal"
    }
  })]), _c('a', {
    staticClass: "r_care",
    attrs: {
      "href": "http://www.carecredit.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar1,
      "alt": "carecredit"
    }
  })]), _c('a', {
    staticClass: "r_banc",
    attrs: {
      "href": "https://www.orthobanc.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar2,
      "alt": "orthobanc"
    }
  })]), _c('a', {
    staticClass: "r_review",
    attrs: {
      "href": "https://goo.gl/UIPSGY/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar3,
      "alt": "goo"
    }
  })]), _c('a', {
    staticClass: "yelp",
    attrs: {
      "href": "https://www.yelp.com/biz/beaumont-orthodontics-beaumont",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.side_bar4,
      "alt": "Beaumont Orthodontics",
      "width": "150",
      "height": "20"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tmj"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-overlay"
  }, [_c('div', {
    staticClass: "loader"
  })])
}]}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jawsurgery"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emergencyinfo"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bandcolorchooser"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ourbeaumonttxoffice"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetthedoctor"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contactus"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome phasewelcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dev) ? _c('div', {
    staticClass: "revisions",
    class: {
      'revisions--active': _vm.active
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active),
      expression: "!active"
    }],
    staticClass: "revisions__button",
    on: {
      "click": function($event) {
        _vm.active = true
      }
    }
  }, [_c('span'), _c('span')]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "revisions__form"
  }, [_c('div', {
    staticClass: "revisions__close",
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._v("CLOSE")]), _c('iframe', {
    attrs: {
      "src": "https://docs.google.com/forms/d/e/1FAIpQLScvQyIzEERaPDDyKzLKZl1YEJPgZ-8ak0z4oEv8JBTAB0UUnQ/viewform?embedded=true",
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0"
    }
  }, [_vm._v("Loading...")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brushingandflossing"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thank-you"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome phasewelcome prphasewelcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "palatalexpander"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome phasewelcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whentoseeanorthodontist"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "referouroffice"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome allfrmptags"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1), _c('h2', [_vm._v("Refer a Friend")]), _vm._m(0), _c('div', {
    staticClass: "main-form nextmainform"
  }, [_c('div', {
    staticClass: "innerapp"
  }, [_c('form', {
    attrs: {
      "action": "https://beaumontortho.com/email/",
      "method": "post"
    }
  }, [_vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfwfFwUAAAAAAUsIWtZ8aO3BS4O8lHPBoIwF7oi",
      "badge": "inline"
    }
  })], 1), _vm._m(7)])])]), _c('div', {
    staticClass: "clearboth"
  }), _c('h2', [_vm._v("Doctor Referral")]), _c('div', {
    staticClass: "left"
  }), _c('p', [_vm._v("If you are a doctor who is referring a patient to us, please fill out and submit the following form.")]), _c('div', {
    staticClass: "clearboth"
  })]), _c('div', {
    staticClass: "main-form"
  }, [_c('div', {
    staticClass: "innerapp"
  }, [_c('form', {
    attrs: {
      "action": "https://beaumontortho.com/email/",
      "method": "post"
    }
  }, [_vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _vm._m(14), _vm._m(15), _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfwfFwUAAAAAAUsIWtZ8aO3BS4O8lHPBoIwF7oi",
      "badge": "inline"
    }
  })], 1), _vm._m(16)])])])])])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('p', [_vm._v("If you are a patient of record who has referred a new patient to us, please let us know by filling out and submitting the following form.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Name ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "flname",
      "id": "flname"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Email ")]), _c('input', {
    attrs: {
      "type": "email",
      "name": "emailID",
      "id": "emailID"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Friend's Name ")]), _c('input', {
    attrs: {
      "type": "friend",
      "name": "friendName",
      "id": "friendName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Your Friend's Phone Number ")]), _c('input', {
    attrs: {
      "type": "phone",
      "name": "phoneNo",
      "id": "phoneNo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Best Time to Call ")]), _c('input', {
    attrs: {
      "type": "timecall",
      "name": "timecall",
      "id": "timeCall"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Comments or Additional Info ")]), _c('textarea', {
    attrs: {
      "name": "message"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt buttonallrt"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "Refer Friend"
    }
  }), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit Referral",
      "onclick": "return validateFRForm()"
    }
  }), _c('p', {
    staticClass: "margin-10"
  }, [_vm._v("* Required")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Today's Date ")]), _c('input', {
    attrs: {
      "type": "date",
      "name": "todayDate",
      "id": "todayDate"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Name ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "yourName",
      "id": "yourName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your Practice Name ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "praticeName",
      "id": "praticeName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Your E-mail Address ")]), _c('input', {
    attrs: {
      "type": "email",
      "name": "emailID1",
      "id": "emailID1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_c('span', [_vm._v("*")]), _vm._v("Full name of the patient you are referring ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "referPName",
      "id": "referPName"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes radioformbox"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Radiographs Sent? ")]), _c('div', {
    staticClass: "radies"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radioGraphs",
      "id": "radioGraphs",
      "value": "Yes",
      "checked": ""
    }
  }), _vm._v("Yes")]), _c('div', {
    staticClass: "radies"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radioGraphs",
      "id": "radioGraphs",
      "value": "No",
      "checked": ""
    }
  }), _vm._v("No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        If yes, when were they sent? ")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "theySent",
      "id": "theySent"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formboxes"
  }, [_c('div', {
    staticClass: "allrt"
  }, [_vm._v("                        Comments ")]), _c('textarea', {
    attrs: {
      "name": "message"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allrt buttonallrt"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "Doctor Referral"
    }
  }), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit Referral",
      "onclick": "return validateDRForm()"
    }
  }), _c('p', {
    staticClass: "margin-10"
  }, [_vm._v("* Required               ")])])
}]}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Glossary"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invisalign"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path !== '/accessibility') ? _c('div', {
    staticClass: "base-access"
  }, [_c('div', {
    staticClass: "base-access__container"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " Accessibility Statement"))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm.companyName + " is committed to facilitating the accessibility and usability of its website, " + _vm.domain + ", for everyone. " + _vm.companyName + " aims to comply with all applicable standards, including the World Wide Web Consortiums Web Content Accessibility Guidelines 2.0 up to Level AA (WCAG 2.0 AA). " + _vm.companyName + " is proud of the efforts that we have completed and that are in-progress to ensure that our website is accessible to everyone."))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(("We highly recommend using the userway accessibility widget linked in the footer, but should you experience any difficulty in accessing any part of this website, please feel free to " + (_vm.phone ? "call us at " + _vm.phone : "") + " " + (_vm.phone && _vm.email ? "or" : "") + " " + (_vm.email ? "email us at " + _vm.email : "") + " and we will work with you to provide the information or service you seek through an alternate communication method that is accessible for you consistent with applicable law (for example, through telephone support)."))
    }
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "home_content"
  })]), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "allcalls"
  }, [_c('router-link', {
    staticClass: "call_unique",
    attrs: {
      "to": "/why-choose-us",
      "target": "_blank"
    }
  }), _c('router-link', {
    staticClass: "call_doctor",
    attrs: {
      "to": "/meet-the-doctors",
      "target": "_blank"
    }
  }), _c('router-link', {
    staticClass: "call_finance",
    attrs: {
      "to": "/financial-and-insurance",
      "target": "_blank"
    }
  }), _c('router-link', {
    staticClass: "call_visit",
    attrs: {
      "to": "/first-visit",
      "target": "_blank"
    }
  })], 1), _c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relatedlinks"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beforeandafterphotos"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "officetourandphotogallery"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "retention"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adulttreatment"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(183);
module.exports = __webpack_require__(182);


/***/ })
],[625]);


// WEBPACK FOOTER //
// static/js/app.js